import {FormControl, Pagination} from 'platform/components';
import {UseDocumentPreviewReturnType} from 'platform/document-preview';
import {Box, HStack, Show} from 'platform/foundation';

import {pushGtmEvent} from 'shared/web';

import {DeliveryNoteDocumentPreviewFormDefinition} from '../types/DeliveryNoteDocumentPreviewFormDefinition';
import {TotalPrice} from './TotalPrice';

interface ListOfItemsTotalPriceWithPaginationProps {
  isConfirmed: boolean;
  control: FormControl<DeliveryNoteDocumentPreviewFormDefinition>;
  documentPreview: UseDocumentPreviewReturnType;
  availablePages: number[];
  currentPage: number;
  hasMoreThanOnePage: boolean;
}

export function ListOfItemsTotalPriceWithPagination(
  props: ListOfItemsTotalPriceWithPaginationProps
) {
  return (
    <Box
      width="100%"
      backgroundColor="palettes.neutral.10.100"
      border="1px solid"
      borderColor="general.separator"
      borderRadius="small"
      paddingHorizontal={3}
      paddingVertical={4}
    >
      <HStack justify={props.hasMoreThanOnePage ? 'space-between' : 'flex-end'} align="center">
        <TotalPrice control={props.control} hasMoreThanOnePage={props.hasMoreThanOnePage} />
        <Show when={props.hasMoreThanOnePage}>
          <Pagination
            showPrevButton
            showNextButton
            showLastButton
            showFirstButton
            page={props.availablePages.indexOf(props.currentPage) + 1}
            pagesQuantity={props.availablePages.length}
            onPageChange={(page) => {
              pushGtmEvent({event: 'button_click', event_id: 'ai_tool_dn_pagination_change'});
              props.documentPreview.controls.setActiveIndex(page - 1);
            }}
          />
        </Show>
      </HStack>
    </Box>
  );
}
